import { config } from '../config'

const intercomAppId = config.analytics.intercom.APP_ID

export default {
  boot: user => {
    if (window.Intercom) {
      if (!user) {
        window.Intercom('boot', {
          app_id: intercomAppId
        })
      } else {
        window.Intercom('boot', {
          app_id: intercomAppId,
          email: user.profile.email,
          user_id: user.profile.envato_id,
          user_hash: user.misc.intercom_user_hash,
          created_at: user.profile.created_at
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./common/utils/bootIntercom.js